import { Button } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";

export function EditPageButtonView({
  onEdit,
}: Readonly<{ onEdit: () => void }>) {
  return (
    <div {...stylex.props(styles.edit)}>
      <Button size="sm" variant="quiet" onClick={onEdit}>
        Edit page
      </Button>
    </div>
  );
}

const styles = stylex.create({ edit: { order: 5 } });
